import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  id: yup.number().required(),
});

const responseSchema = yup.array().of(
  yup.object({
    expiresAt: yup.string().nullable(),
    imageType: yup.string().required(),
    url: yup.string().required(),
  }),
);

const composeResponse = (res) => {
  return res?.data?.data || [];
};

export const useLeadImagesQuery = (payload, options = {}) => {
  return useQuery(
    [QUERY_KEYS.lead.images, payload.id],
    async () => {
      const req = requestSchema.validateSync(payload);
      const res = await http.get(HTTP_ENDPOINTS.getLeadAgelessImages(req.id));
      return responseSchema.validateSync(composeResponse(res));
    },
    options,
  );
};
